import { Component } from '@angular/core';
import { ChartDataset } from 'chart.js';
import { DisplayUnit } from 'src/app/panels/models/display-unit';
import { GenerateGraphDataset, GraphType, IGraphConfig, IGraphMappedDataset } from 'src/app/panels/models/graph';
import { PanelType } from 'src/app/panels/models/panel-type';
import { Color } from 'src/app/shared/services/color/colors';
import {
  GRAPH_PANEL_IMPORTS,
  GraphPanelComponent,
} from '../../../../panels/components/graph-panel/graph-panel.component';
import { PanelComponent } from '../../../../panels/components/panel.component';

@PanelComponent.register
@Component({
  templateUrl: '../../../../panels/components/graph-panel/graph-panel.component.html',
  styleUrl: '../../../../panels/components/graph-panel/graph-panel.component.scss',
  selector: 'app-benchmarking-graph-panel',
  imports: GRAPH_PANEL_IMPORTS,
})
export class BenchmarkingGraphPanelComponent extends GraphPanelComponent {
  public static override readonly type = PanelType.BenchmarkingGraph;
  public override unit = DisplayUnit.KwhSquareMeter;

  public override config: IGraphConfig = {
    sortOrder: [GraphType.EnvironmentElectricityBenchmarking, GraphType.EnvironmentGasBenchmarking],
    getGraphTypeDataset: this.getGraphTypeDataset,
  };

  protected override graphInfo = {
    title: 'Benchmarking grafiek',
    description: `
      <p>
        Vergelijk het huidige energieverbruik met dezelfde periode in voorgaande jaren. Hiervoor is minimaal 2 jaar historische data nodig.
        Deze vergelijking laat zien of de energieprestatie van het gebouw verbetert of verslechtert ten opzichte van eerdere jaren.
      </p>
      `,
  };

  private getGraphTypeDataset(
    generateDataset: GenerateGraphDataset,
    dataset: IGraphMappedDataset,
    startTimestamps: string[],
    endTimestamps: string[],
  ): ChartDataset {
    switch (dataset.type) {
      case GraphType.EnvironmentElectricityBenchmarking:
        return generateDataset(
          dataset,
          startTimestamps,
          endTimestamps,
          'Electriciteit',
          Color.Purple,
          DisplayUnit.KwhSquareMeter,
        );
      case GraphType.EnvironmentGasBenchmarking:
        return generateDataset(dataset, startTimestamps, endTimestamps, 'Gas', Color.Gray, DisplayUnit.KwhSquareMeter);
      default:
        throw new Error(`No dataset specified for GraphType '${dataset.type}'`);
    }
  }
}
